// Web counterpart to firebaseConfig.ts. Phase 5 launch-prep audit confirmed
// a dedicated Firebase Web app was already registered in this project
// (display name "triptribe-web", `firebase apps:list --project
// triptribe-8babd`) but never actually used — the shared firebase.ts file
// was initializing with the iOS app's apiKey/appId on every platform,
// including web, which is functionally harmless (any registered app's
// apiKey can reach the same project's backend) but misattributes web
// traffic to the iOS app in Firebase Analytics/App Check. Same project
// (triptribe-8babd), same authDomain/storageBucket/messagingSenderId —
// only the apiKey/appId/measurementId differ, matching this app's own
// dedicated registration (`firebase apps:sdkconfig WEB
// 1:138042732807:web:e6f0d72d66d3d4859055a2`).
export const firebaseConfig = {
  apiKey: 'AIzaSyCg-jED0PJWqhYlIawglqftUtGHb5GOvW4',
  authDomain: 'triptribe-8babd.firebaseapp.com',
  projectId: 'triptribe-8babd',
  storageBucket: 'triptribe-8babd.firebasestorage.app',
  messagingSenderId: '138042732807',
  appId: '1:138042732807:web:e6f0d72d66d3d4859055a2',
  measurementId: 'G-EF3J02Z2QL',
};
